import React, { useEffect } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '../common/LoadingOverlay';

/**
 * ProtectedRoute Component
 * Ensures user is authenticated via Auth0 before accessing routes
 * Shows loading state while checking authentication
 * Automatically redirects to login if not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const { t } = useTranslation('common');

  useEffect(() => {
    // If not loading and no user, redirect to login
    if (!isLoading && !user) {
      // Check if we're coming from a logout
      const isPostLogout = window.sessionStorage.getItem('post_logout');
      if (!isPostLogout) {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`;
      } else {
        // Clear the post_logout flag
        window.sessionStorage.removeItem('post_logout');
      }
    }
  }, [isLoading, user]);

  if (isLoading) {
    return <LoadingOverlay message={t('common.loading')} />;
  }

  // If we have a user, render the protected content
  if (user) {
    return children;
  }

  // This will briefly show while the redirect happens
  return <LoadingOverlay message={t('common.redirecting')} />;
};

export default ProtectedRoute; 